import './index.css';
import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/captions.css';
import 'react-calendar/dist/Calendar.css';

import { AppRegistry } from 'react-native-web';
import { enableLegacyWebImplementation } from 'react-native-gesture-handler';
import moment from 'moment';
import { en, registerTranslation } from 'react-native-paper-dates'

import { progressFetch } from './modules/helpers';

import App from './App';

// Generate the required CSS
import materialFont from 'react-native-vector-icons/Fonts/MaterialIcons.ttf';
import materialCommunityFont from 'react-native-vector-icons/Fonts/MaterialCommunityIcons.ttf';
import featherFont from 'react-native-vector-icons/Fonts/Feather.ttf';
import awesomeFont from 'react-native-vector-icons/Fonts/FontAwesome.ttf';
const iconFontStyles = `
    @font-face {
        src: url(${materialFont});
        font-family: MaterialIcons;
    }
    
    @font-face {
        src: url(${materialCommunityFont});
        font-family: MaterialCommunityIcons;
    }
    
    @font-face {
        src: url(${featherFont});
        font-family: Feather;
    }
    
    @font-face {
        src: url(${awesomeFont});
        font-family: FontAwesome;
    }
`;

// Register Translations for date picker
registerTranslation('en', en);

// Create a stylesheet
const style = document.createElement('style');
style.type = 'text/css';

// Append the iconFontStyles to the stylesheet
if (style.styleSheet) {
    style.styleSheet.cssText = iconFontStyles;
} else {
    style.appendChild(document.createTextNode(iconFontStyles));
}

// Inject the stylesheet into the document head
document.head.appendChild(style);

// Fix for React Native Reanimated Carousel
enableLegacyWebImplementation(true);

// Override original fetch with progressFetch
const originalFetch = fetch;
global.fetch = (url, opts) => {
    if (opts?.onProgress && typeof opts.onProgress === 'function') {
        return progressFetch(url, opts, opts.onProgress);
    }
    else return originalFetch(url, opts);
};

// Update moment configs
moment.relativeTimeThreshold('m', 59);
moment.updateLocale('en', {
    week: {
        dow: 1 // Monday is the first day of the week.
    }
});
moment.locale('en');

// Register app
AppRegistry.registerComponent('App', () => App);
AppRegistry.runApplication('App', {
    rootTag: document.getElementById('root')
});
